<template>
  <div
    class="setting-popup setting-popup--video"
    v-show="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >使用教程</div>
    <div class="setting-popup__content">
      <ul>
        <li
          v-for="(v, i) in courseTitles"
          :key="i"
          class="item"
          @click="openAnimCourse(v.id)"
        >
          <span>{{v.title}}</span>
        </li>
      </ul>
    </div>
    <!-- <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div> -->
    <div
      class="setting-popup__mask"
      v-show="isShowMask"
      @click="closeNextPopup('color')"
    ></div>
  </div>
</template>

<script>
import popup from '../mixins/popup';

export default {
  mixins: [popup],
  data () {
    return {
      popupType: 'anim-course',
      courseTitles: []
    };
  },
  watch: {
    'boxData.judgeBox' (val) {
      if (val) {
        this.$bus.emit('getApiCourse');
      }
    }
  },
  created () {
    this.$bus.on('animCourse.getTitles', (list) => {
      this.courseTitles = list;
    });
  },
  methods: {
    openAnimCourse (courseId) {
      this.$analysis(`hover_botton,click_course_${courseId},悬浮按钮_点击_教程_${courseId}`);
      this.$bus.emit('openCourseById', courseId);
      this.$store.commit('save_TopnavMsg', {
        isShowAnimCourseDialog: true
      });
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 290px;
  // min-height: 216px;
  max-height: 562px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    padding-top: 11px;
    line-height: 28px;
    text-align: center;
    text-indent: 14px;
    font-weight: bold;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0 24px;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.item {
  display: flex;
  align-items: center;
  width: 248px;
  height: 28px;
  margin: auto;
  margin-top: 10px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  cursor: pointer;

  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 0px;
  color: #838383;

  &:first-child {
    margin-top: 0;
  }

  &:hover {
    border-color: #7b7bff;
    background-color: #7b7bff;
    color: #fff;
    &:before {
      background-color: #fff;
    }
  }

  &:before {
    content: ' ';
    display: inline-block;
    width: 24px;
    height: 24px;
    transform: scale(0.25);
    background-color: #8b8b8b;
    border-radius: 50%;
    margin-left: 0.25em;
    margin-right: 0.25em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/course.vue